import { useEffect, useRef, useState } from 'react';

const useIncludeManager = ({ selectedTicketId, navigate, fetchWrapper }) => {
  const [showIncludeModal, setShowIncludeModal] = useState(false);
  const [selectedIncludeShape, setSelectedIncludeShape] = useState(null);
  const [includeFoldersData, setIncludeFoldersData] = useState(null);
  const [isLoadingIncludeData, setIsLoadingIncludeData] = useState(false);
  const [selectedIncludePath, setSelectedIncludePath] = useState(null);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [includeFilesData, setIncludeFilesData] = useState(null);
  const [isLoadingFiles, setIsLoadingFiles] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [shapeIncludePaths, setShapeIncludePaths] = useState({});
  const [shapeIncludeFolders, setShapeIncludeFolders] = useState({});
  const [shapeOriginalLabels, setShapeOriginalLabels] = useState({});
  const [shapesWithInclude, setShapesWithInclude] = useState(new Set());
  const [includeError, setIncludeError] = useState(null);
  const [showIncludeInfoModal, setShowIncludeInfoModal] = useState(false);
  const [includeInfoData, setIncludeInfoData] = useState(null);

  const shapeIncludePathsRef = useRef({});
  const shapeIncludeFoldersRef = useRef({});

  useEffect(() => {
    if (showIncludeModal && selectedIncludeShape) {
      setIsLoadingIncludeData(true);
      setIncludeFoldersData(null);
      setSelectedIncludePath(null);
      setSelectedFolder(null);
      setIncludeFilesData(null);
      setSelectedFile(null);
      setIncludeError(null);

      const fetchIncludeData = async () => {
        try {
          const processId = process.env.REACT_APP_ADD_INCLUDE;
          if (!processId) {
            throw new Error('REACT_APP_ADD_INCLUDE environment variable tanımlı değil!');
          }

          const token = localStorage.getItem('token');
          const bodyParams = {
            token: token,
            TICID: selectedTicketId,
          };

          const response = await fetchWrapper(processId, bodyParams, navigate);

          if (response && (response.result || response.success || response.data)) {
            const responseData = response.result || response.data || response;
            setIncludeFoldersData(responseData);
            setIsLoadingIncludeData(false);
          } else {
            throw new Error(response?.error || response?.message || 'Veri alınamadı');
          }
        } catch (error) {
          setIncludeError(error.message || 'Veri yüklenirken bir hata oluştu');
          setIsLoadingIncludeData(false);
        }
      };

      fetchIncludeData();
    }
  }, [showIncludeModal, selectedIncludeShape, selectedTicketId, navigate, fetchWrapper]);

  useEffect(() => {
    shapeIncludePathsRef.current = shapeIncludePaths;
  }, [shapeIncludePaths]);

  useEffect(() => {
    shapeIncludeFoldersRef.current = shapeIncludeFolders;
  }, [shapeIncludeFolders]);

  useEffect(() => {
    if (selectedFolder && (selectedFolder.folderName || selectedFolder.foldername)) {
      setIsLoadingFiles(true);
      setIncludeFilesData(null);
      setSelectedFile(null);
      setIncludeError(null);

      const fetchFilesData = async () => {
        try {
          const processId = process.env.REACT_APP_ADD_INCLUDE_FILE;
          if (!processId) {
            throw new Error('REACT_APP_ADD_INCLUDE_FILE environment variable tanımlı değil!');
          }

          const foldername = selectedFolder.foldername || selectedFolder.folderName;
          const bodyParams = {
            foldername: foldername,
            process: processId,
          };

          const response = await fetchWrapper(processId, bodyParams, navigate);

          if (response && (response.result || response.success || response.data)) {
            const responseData = response.result || response.data || response;
            setIncludeFilesData(responseData);
            setIsLoadingFiles(false);
          } else {
            throw new Error(response?.error || response?.message || 'File listesi alınamadı');
          }
        } catch (error) {
          console.error('Include files fetch hatası:', error);
          setIncludeError(error.message || 'File listesi yüklenirken bir hata oluştu');
          setIsLoadingFiles(false);
        }
      };

      fetchFilesData();
    }
  }, [selectedFolder, selectedTicketId, navigate, fetchWrapper]);

  return {
    showIncludeModal,
    setShowIncludeModal,
    selectedIncludeShape,
    setSelectedIncludeShape,
    includeFoldersData,
    setIncludeFoldersData,
    isLoadingIncludeData,
    selectedIncludePath,
    setSelectedIncludePath,
    selectedFolder,
    setSelectedFolder,
    includeFilesData,
    setIncludeFilesData,
    isLoadingFiles,
    selectedFile,
    setSelectedFile,
    shapeIncludePaths,
    setShapeIncludePaths,
    shapeIncludeFolders,
    setShapeIncludeFolders,
    shapeOriginalLabels,
    setShapeOriginalLabels,
    shapesWithInclude,
    setShapesWithInclude,
    includeError,
    setIncludeError,
    showIncludeInfoModal,
    setShowIncludeInfoModal,
    includeInfoData,
    setIncludeInfoData,
    shapeIncludePathsRef,
    shapeIncludeFoldersRef,
  };
};

export default useIncludeManager;
